<div class="dark:text-gray-100 dark:bg-transparent grid grid-rows-1 grid-flow-col gap-4">
  <div class="tab" (click)="setOpenTab(1)" [ngClass]="{' bg-navy ': openTab !== 1, ' active bg-blue-600 ': openTab === 1}">Exentos Autorizados</div>
</div>
<br>

<div [ngClass]="{'hidden': openTab !== 1, 'block': openTab === 1}" class="">
<!-- formuralio -->
<form [formGroup]="formExentos">
  <div  class="mb-2 p-1 w-full h-auto border rounded border-solid border-gray-300 dark:border-gray-500 font-semibold text-base text-gray-500 dark:text-gray-200">
    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center" >REGISTRO DE PERSONA</div>
    <div class="grid grid-cols-4 grid-flow-col gap-4">
      <div>
        <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >NOMBRE</div>
        <input type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" placeholder={{nombrePlaceHolder}} formControlName="nombre">
      </div>
      <!-- <div>
        <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >A.PATERNO</div>
        <input type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" placeholder="NOMBRE COMPLETO" formControlName="nombre">
      </div>
      <div>
        <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >A.MATERNO</div>
        <input type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" placeholder="NOMBRE COMPLETO" formControlName="nombre">
      </div> -->
      <div *ngIf="!registroVehiculo">
        <button class="estilo-dark dark:text-gray-100 dark:bg-blue-600 uppercase" (click)="savePersona(true)">AGREGAR</button>
      </div>
    </div>
    <hr>
  <div *ngIf="registroVehiculo">
    <div>
      <div>
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center" >REGISTRO DE VEHICULO</div>
      <form [formGroup]="vehiculosForm">
      <div class="grid grid-cols-4 gap-4">
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >No. tarjetón</div>
          <input formControlName="tarjeton"  type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" placeholder="No. Tarjeton">
        </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Fecha Registro</div>
          <input formControlName="fecha_registro" type="date" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
        </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Tarjetón Activo Hasta:</div>
          <input formControlName="fecha_valido" type="date" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
        </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Modelo</div>
          <input formControlName="modelo" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
        </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Marca</div>
          <input formControlName="marca" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
        </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Año</div>
          <input formControlName="anio" type="number" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
        </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >No. Económico</div>
          <input formControlName="no_economico" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
        </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Tipo de Pase</div>
          <select (change)="getFolioTarjeton()" formControlName="tipo_pase" class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700">
            <option value="" selected disabled>Tipo de Pase</option>
            <option *ngFor="let tipo  of tipoPases" value="{{ tipo.id }}">{{ tipo.nombre }}</option>
          </select>
        </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Estatus</div>
          <select formControlName="estatus" class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700">
            <option value="" disabled>Estatus</option>
            <option value="1" selected>Activo</option>
            <option value="2">Suspendido</option>
            <option value="3">Inactivo</option>
          </select>
        </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Tipo</div>
            <input formControlName="tipo" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
        </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Placas</div>
            <input formControlName="placa" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
        </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Descuento(%)</div>
          <select formControlName="descuento" class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700">
            <option *ngFor="let descuento of descuentos" value="{{ descuento.id }}">{{ descuento.descuento }}</option>
          </select>
        </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Linea</div>
            <input formControlName="linea" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
          </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Dependencia</div>
            <input formControlName="dependencia" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
          </div>
        <div>
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Poblado</div>
          <input formControlName="poblado" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
        </div>
        <!---->
        <div>
            <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Valido Plaza</div>
            <div >
              <div formArrayName="plazas" class="grid grid-cols-3">
                <div *ngFor="let control of vehiculosForm.get('plazas').controls; let i = index">
                  <label>
                    <input type="checkbox" checked="false" [formControl]="control" id="{{ arrayPlazas[i] }}"/>
                    {{ arrayPlazas[i] }}
                  </label>
                </div>
              </div>
            </div>
        </div>
      <!---->
        <div class="col-span-3">
          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Observaciones</div>
            <textarea formControlName="observaciones" class="dark:bg-gray-700 dark:text-gray-100 flex text-center items-center text-black  w-full border"></textarea>
        </div>
        <div>
          <button *ngIf="!editarDatosVehiculo" [disabled]="!this.vehiculosForm.valid" class="estilo-dark dark:text-gray-100 dark:bg-blue-600 uppercase" (click)="addVehiculo()">
            AGREGAR
          </button>
          <button *ngIf="editarDatosVehiculo"  [disabled]="!this.vehiculosForm.valid" class="estilo-dark dark:text-gray-100 dark:bg-blue-600 uppercase" (click)="modificarEdit()">
            MODIFICAR
          </button>
          <button *ngIf="editarDatosVehiculo"  class="estilo-dark dark:text-gray-100 dark:bg-blue-600 uppercase" (click)="cancelarEdit()">
            CANCELAR
          </button>
        </div>
      </div>
      </form>
      </div>
    </div>
  </div>
    <!-- Lista de vehiculo -->
    <hr>
    <h4 class="text-center w-full text-gray-800 dark:text-gray-100">LISTA DE VEHICULOS</h4>
      <div *ngIf="vehiculos.length > 0" class="flex gap-8 items-center justify-center text-center w-full h-44 overflow-y-scroll">
          <!-- Contenido de Table con los autos de la persona -->
            <table class="w-3/4 text-center border-collapse border-spacing-2 border border-slate-500">
              <thead>
                <tr>
                  <th class="border border-slate-600">Fecha Valido</th>
                  <th class="border border-slate-600">No. Tarjetón</th>
                  <th class="border border-slate-600">No. Placa</th>
                  <th class="border border-slate-600">Modelo</th>
                  <th class="border border-slate-600">Marca</th>
                  <th class="borde border-slate-600 col-span-2">Acciones</th>
                </tr>
              </thead>
              <tbody *ngFor="let vehiculo of vehiculos.controls; let i = index">
                <tr>
                  <td class="border border-slate-700">{{ vehiculo.get('fecha_valido').value }}</td>
                  <td class="border border-slate-700">{{ vehiculo.get('tarjeton').value }}</td>
                  <td class="border border-slate-700">{{ vehiculo.get('placa').value }}</td>
                  <td class="border border-slate-700">{{ vehiculo.get('modelo').value }}</td>
                  <td class="border border-slate-700">{{ vehiculo.get('marca').value }}</td>
                  <td class="border border-slate-700">
                    <button (click)="eliminarRow(i, vehiculo)" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-md px-4 py-2 bg-blue-700 font-medium text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                      Eliminar
                    </button>
                  </td>
                  <td class="border border-slate-700">
                    <button (click)="editarRow(i)" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-md px-4 py-2 bg-blue-700 font-medium text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                      Editar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div>
              <button *ngIf="(idsVehiculos.length > 0)" class="estilo-dark dark:text-gray-100 dark:bg-blue-600 uppercase" (click)="downloadTarjetonesPDF()">DESCARGAR PDF</button>
              <button *ngIf="!(idsVehiculos.length > 0)" class="estilo-dark dark:text-gray-100 dark:bg-blue-600 uppercase" (click)="saveVehiculosPersona()">GUARDAR</button>
            </div>
      </div>
      <!-- fin lista de vehiculos -->
  </div>
</form>
<!-- busqueda -->
<br>
<h5 class="m-2 text-center w-full text-gray-800 dark:text-gray-100">Busqueda Personalizada</h5>
<form [formGroup]="formBusqueda">
<div class="grid grid-cols-4 gap-4">
  <div class="col-span-1">
    <select formControlName="tipo_pase" class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700">
      <option value="" selected>Tipo de Pase</option>
      <option *ngFor="let tipo  of tipoPasesGeneral" value="{{ tipo.id }}">{{ tipo.nombre }}</option>
    </select>
  </div>
  <div class="col-span-2">
    <div class="relative">
      <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
          </svg>
      </div>
      <input formControlName="no_tarjeton" type="search" id="default-search" class="search w-full" placeholder="Ingresa el número de tarjetón ....">
    </div>
  </div>
  <div class="col-span-1">
    <button (click)="buscarVehiculos()" class="w-full inline-flex gap-3 justify-center rounded-md border border-transparent shadow-md px-4 py-2 bg-blue-700 font-medium text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
      <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
    </svg>
      Buscar
    </button>
  </div>
</div>
</form>
<br>

<ngx-datatable
#myTable
class="material expandable"
[rows]="exentos"
[groupRowsBy]="'id_persona'"
[columnMode]="ColumnMode.force"
[scrollbarH]="true"
[headerHeight]="40"
[footerHeight]="40"
[rowHeight]="70"
[limit]="10"
[groupExpansionDefault]="false"
>
<!-- Group Header Template -->
<ngx-datatable-group-header [rowHeight]="50" #myGroupHeader >
  <ng-template let-group="group" let-expanded="expanded" ngx-datatable-group-header-template>
    <div style="padding-left:5px;">
      <a
      href="javascript:void(0);"
      [class.datatable-icon-right]="!expanded"
      [class.datatable-icon-down]="expanded"
      title="Expand/Collapse Group"
      (click)="toggleExpandGroup(group)"
      >
        <b>Nombre: {{ group.value[0].persona?.nombre | uppercase}}</b>
      </a>
    </div>
  </ng-template>
</ngx-datatable-group-header>

<!-- Row Column Template -->
<ngx-datatable-column name="VALIDO HASTA" prop="fecha_valido" [maxWidth]="180">
  <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
      {{ value | date: 'dd/MM/YYYY' }}
  </ng-template>
</ngx-datatable-column>
<ngx-datatable-column name="PLACA" prop="placa" [maxWidth]="200">
<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
    {{ value }}
</ng-template>
</ngx-datatable-column>
<ngx-datatable-column name="MARCA Y MODELO" prop="marca">
<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
  {{ value | uppercase }}, {{ row.modelo | uppercase }}
</ng-template>
</ngx-datatable-column>
<ngx-datatable-column name="ESTATUS" prop="estatus" [maxWidth]="100">
  <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
      {{ estatus[value] | uppercase}}
  </ng-template>
</ngx-datatable-column>
<ngx-datatable-column name="TIPO PASE" prop="tipo_pase" [maxWidth]="180">
  <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
     {{row.no_tarjeton}}, {{ value | uppercase}}
  </ng-template>
</ngx-datatable-column>
<ngx-datatable-column name="ACCIONES" prop="id" [minWidth]="300">
<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
  <div>
     <button (click)="openModalEdit(value)" style="display: inline-flex" class="ml-1 btn-primary">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
      Editar
    </button>
    <button (click)="downloadTarjetonVehiculo(row)" style="display: inline-flex" class="ml-1 btn-warning">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
      Tarjeton
    </button>
    <button (click)="mostrarHistorialExcento(value)" style="display: inline-flex" class="ml-1 btn-info">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
      Historial
    </button>
  </div>

</ng-template>
</ngx-datatable-column>
</ngx-datatable>
<br>

<!-- Modales -->
<!-- MODAL PARA PREVISUALIZAR EL DOCUMENTO -->

<div *ngIf="modalEditUser" class="modal-component-container fixed inset-0 overflow-y-auto">
  <div class="modal-flex-container flex items-end justify-center max-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75"></div>
      <div class="modal-space-container hidden sm:inline-block sm:align-middle sm:h-screen">&nbsp;</div>
      <div class="modal-container inline-block align-bottom bg-white dark:bg-gray-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl w-full">
        <div class="modal-wrapper bg-white dark:bg-gray-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="modal-wrapper-flex sm:flex sm:items-start">
            <div class="modal-content mt-3 w-full sm:mt-0 sm:ml-0 sm:text-left space-y-3">
              <div class="flex items-center justify-between">
                <div class="flex items-center flex-col space-y-2 rounded py-1 w-full">
                  <div class="grid grid-cols-1 grid-flow-col gap-4">
                    <form [formGroup]="formEditUser">
                      <div>
                        <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >NOMBRE</div>
                        <input formControlName="nombre" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" placeholder="NOMBRE COMPLETO">
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-actions bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse dark:bg-gray-800">
          <button (click)="dismissModalUser(true)"
          class="w-full inline-flex justify-center bg-blue-600 rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3  font-medium text-white  hover:text-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
              Cambiar Todos
          </button>
          <button (click)="changeIndex()"
          class="w-full inline-flex justify-center bg-teal-800 rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3  font-medium text-white  hover:text-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
              Cambiar Unico
          </button>
          <button (click)="dismissModalUser(false)"
          class="w-full inline-flex justify-center bg-red-600 rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3  font-medium text-white  hover:text-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
              Cerrar
          </button>
        </div>
      </div>
  </div>
</div>

<!-- MODAL SUBIR DOCUMENTOS VALIDACION EXENTOS -->
<div *ngIf="modalUploadDocExe" class="modal-component-container w-full fixed inset-0 overflow-y-auto">
  <div class="modal-flex-container flex items-center justify-center max-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75"></div>
    <div class="modal-space-container hidden sm:inline-block sm:align-middle sm:max-h-screen">&nbsp;</div>
    <div class="modal-container h-1/4 inline-block align-bottom bg-white dark:bg-gray-800 rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full max-w-4xl"> <!-- Cambia max-w-4xl según el ancho deseado -->
      <div class="modal-wrapper bg-white dark:bg-gray-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4 overflow-y-auto" style="height: 90vh;">
      <button type="button" class="btn btn-danger float-right" (click)="closeModalDocExe()">CERRAR</button>
        <form [formGroup]="formExeDocumento">
          <div class="flex items-center justify-between">
            <div class="flex items-center flex-col space-y-2 rounded py-1 w-full">
              <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center border-white rounded-lg">VALIDAR TARJETÓN</div>
              <hr class="border-white">
                <input type="text" hidden formControlName="id" name="id" id="id">
                <div *ngIf="formExeDocumento.get('persona') else formVehiculo">
                  <div class="flex gap-2">
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase pt-5">PERSONA:</div>
                    <input type="text" disabled formControlName="persona" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                  </div>
                </div>
                <ng-template #formVehiculo>
                  <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-left border-white rounded-lg">DATOS VEHICULO</div>
                  <div class="grid grid-cols-3 gap-4 overflow-y-auto">
                    <div class="flex gap-3 col-span-3 content-center justify-center">
                      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase pt-5">Placas:</div>
                      <input type="text" disabled formControlName="placas" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                    </div>
                    <div class="flex gap-3 col-span-3">
                      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase col-span-3">No. tarjetón</div>
                      <input formControlName="tarjeton"  type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" placeholder="No. Tarjeton">
                    </div>
                    <div class="col-span-3 justify-center">
                      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase col-span-3">Tipo de Pase</div>
                      <select formControlName="tipo_pase" class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700">
                        <option value="" selected disabled>Tipo de Pase</option>
                        <option *ngFor="let tipo  of tipoPases" value="{{ tipo.id }}">{{ tipo.nombre }}</option>
                      </select>
                    </div>
                  </div>
                </ng-template>
                  <!-- lista documentos -->
                  <div class="w-full" *ngIf="rowsDocumentos != null; else cargandoDocumentos">
                    <ngx-datatable
                      #tableDocumentos
                      class="material"
                      [rows]="rowsDocumentos"
                      [columnMode]="ColumnMode.force"
                      [headerHeight]="50"
                      [footerHeight]="50"
                      rowHeight="auto"
                      [limit]="5"
                      [selectionType]="SelectionType.single"
                      [selected]="selected"
                      (activate)="onActivate($event)"
                      (select)="onSelect($event)"
                      [scrollbarV]="true"
                      [virtualization]="false">
                      <!-- colums -->
                      <ngx-datatable-column name="FECHA REGISTRO" prop="fecha_hora">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                          <ng-container>
                            {{ value | date: 'yyyy-MM-dd' }}
                          </ng-container>
                        </ng-template>
                      </ngx-datatable-column>
                      <ngx-datatable-column name="NOMBRE DEL ARCHIVO" prop="name_file">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                          <ng-container>
                            {{ value }}
                          </ng-container>
                        </ng-template>
                      </ngx-datatable-column>
                      <ngx-datatable-column name="ACCIONES" prop="id">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                          <div class="place-items-center 2 border-b border-gray-200 cursor-pointer">
                            <button (click)="viewDocCertificado(row)" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-md px-4 py-2 bg-blue-700 font-medium text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3 6v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3H6a3 3 0 00-3 3zm5 0v2m0 4v2m0 4v2m8-10v4h-2V8h2zm-4 0v6H9V8h3zm0 0h4v4h-4V8z" />
                              </svg>
                              VER DOCUMENTO
                            </button>
                          </div>
                        </ng-template>
                      </ngx-datatable-column>
                    </ngx-datatable>
                  </div>
                  <ng-template #cargandoDocumentos class="w-full text-center dark:text-gray-50 text-gray-800 text-sm">
                    <h3 class="text-center dark:text-white text-gray-900 text-sm">Aún no se registra ningún documento.</h3>
                  </ng-template>
                <div class="col-span-3 text-center justify-center flex-row gap-1">
                  <label for="validar" class="m2 font-bold dark:text-gray-100">¿Deseas agregar algún documento para finalizar la certificación?</label>
                  <input class="gap-3 ml-3 text-xl w-6 h-6" formControlName="check_file" type="checkbox" name="validar" id="validar" (change)="changeFileCheck()">
                </div>
                <!-- file -->
                <div *ngIf="fileCheck" class="col-span-3">
                   <label for="archivo" class="block mb-2 font-bold dark:text-gray-100 text-center">Seleccionar archivo:</label>
                    <input type="file" id="archivo" name="archivo" formControlName="file" (change)="onFileSelected($event)" class="border border-gray-400 py-2 px-4 rounded-lg w-full dark:text-gray-100 dark:bg-gray-700">
                </div>
                <div class="col-start-2 col-span-1">
                  <button [disabled]="!this.formEditVehiculo.valid" class="estilo-dark dark:text-gray-100 dark:bg-blue-600 uppercase" (click)="modificarVehiculo()">GUARDAR CERTIFICADO</button>
                </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- MODAL EDITAR VEHICULO -->
<div *ngIf="modalEdit" class="modal-component-container w-full fixed inset-0 overflow-y-auto">
  <div class="modal-flex-container flex items-center justify-center max-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75"></div>
    <div class="modal-space-container hidden sm:inline-block sm:align-middle sm:max-h-screen">&nbsp;</div>
    <div class="modal-container h-1/4 inline-block align-bottom bg-white dark:bg-gray-800 rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full max-w-4xl">
      <div class="modal-wrapper bg-white dark:bg-gray-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4 overflow-y-auto" style="height: 90vh;">
      <button type="button" class="btn btn-danger float-right" (click)="closeModalEdit()">CERRAR</button>
        <form [formGroup]="formEditVehiculo">
          <div class="flex items-center justify-between">
            <div class="flex items-center flex-col space-y-2 rounded py-1 w-full">
              <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center border-white rounded-lg">EDITAR REGISTRO</div>
                <div class="flex gap-2">
                  <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase pt-5">PERSONA:</div>
                  <input type="text" disabled formControlName="persona" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                  <button (click)="openModalEditUser(vehiculoEdit.nombre, vehiculoEdit.id_persona)" class="m-2 gap-2 btn btn-success flex align-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    Editar
                  </button>
                </div>
                <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-left border-white rounded-lg">DATOS DEL TARJERON</div>
                <div class="grid grid-cols-3 gap-4 overflow-y-auto">
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >No. tarjetón</div>
                    <input formControlName="tarjeton"  type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" placeholder="No. Tarjeton">
                  </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Fecha Registro</div>
                    <input formControlName="fecha_registro" type="date" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                  </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Tarjetón Activo Hasta:</div>
                    <input formControlName="fecha_valido" type="date" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                  </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Modelo</div>
                    <input formControlName="modelo" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                  </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Marca</div>
                    <input formControlName="marca" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                  </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Año</div>
                    <input formControlName="anio" type="number" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                  </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >No. Económico</div>
                    <input formControlName="no_economico" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                  </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Tipo de Pase</div>
                    <!--<select (change)="getTarjetonEdit()" formControlName="tipo_pase" class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700"> -->
                    <select formControlName="tipo_pase" class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700">
                      <option value="" selected disabled>Tipo de Pase</option>
                      <option *ngFor="let tipo  of tipoPases" value="{{ tipo.id }}">{{ tipo.nombre }}</option>
                    </select>
                  </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Estatus</div>
                    <select formControlName="estatus" class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700">
                      <option value="" disabled>Estatus</option>
                      <option value="1" selected>Activo</option>
                      <option value="2">Suspendido</option>
                      <option value="3">Inactivo</option>
                    </select>
                  </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Tipo</div>
                      <input formControlName="tipo" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                  </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Placas</div>
                      <input formControlName="placa" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                  </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Descuento(%)</div>
                    <select formControlName="descuento" class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700">
                      <option *ngFor="let descuento of descuentos" value="{{ descuento.id }}">{{ descuento.descuento }}</option>
                    </select>
                  </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Linea</div>
                      <input formControlName="linea" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                    </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Dependencia</div>
                      <input formControlName="dependencia" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                    </div>
                  <div>
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase" >Poblado</div>
                    <input formControlName="poblado" type="text" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                  </div>
                  <!---->
                  <div class="col-span-3">
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Valido Plaza</div>
                    <div >
                      <div formArrayName="plazas" class="grid grid-cols-3 text-gray-50 font-bold">
                        <div *ngFor="let control of formEditVehiculo.get('plazas').controls; let i = index">
                          <label>
                            <input type="checkbox" [formControl]="control" id="{{ arrayPlazas[i] }}"/>
                            {{ arrayPlazas[i] }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!---->
                  <div class="col-span-3">
                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Observaciones</div>
                      <textarea formControlName="observaciones" class="dark:bg-gray-700 dark:text-gray-100 flex text-center items-center text-black  w-full border"></textarea>
                    </div>
                  <div class="col-start-2 col-span-1">
                    <button [disabled]="!this.formEditVehiculo.valid" class="estilo-dark dark:text-gray-100 dark:bg-blue-600 uppercase" (click)="modificarVehiculo()">MODIFICAR</button>
                    <button class="estilo-dark dark:text-gray-100 dark:bg-red-600 uppercase flex" (click)="openModalCertificado('vehiculo', vehiculoEdit.id)">
                      {{ vehiculoEdit.name_file != null ? 'MODIFICAR CERTIFICADO' : 'CERTIFICAR TARJETON' }}
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                  </div>
                </div>
            </div>
          </div>
          </form>
      </div>
    </div>
  </div>
</div>

<!-- MODAL PARA MOSTRAR EL HISTORIAL -->
<div *ngIf="modalShowHistorial" class="modal-component-container w-full fixed inset-0 overflow-y-auto">
  <div class="modal-flex-container flex items-center justify-center max-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75"></div>
    <div class="modal-space-container hidden sm:inline-block sm:align-middle sm:max-h-screen">&nbsp;</div>
    <div class="modal-container h-1/4 inline-block align-bottom bg-white dark:bg-gray-800 rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full max-w-4xl"> <!-- Cambia max-w-4xl según el ancho deseado -->
      <div class="modal-wrapper bg-white dark:bg-gray-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4 overflow-y-auto" style="height: 90vh;">
      <button type="button" class="btn btn-danger float-right" (click)="closeModalHistorial()">CERRAR</button>
        <h2 class="text-xl font-bold mb-4 dark:text-white">Historial de Cambios del Vehículo</h2>

        <ngx-datatable-row-detail [rowHeight]="250" #tablaHistorial>
          <ng-template let-row="row" ngxDatatableRowDetailTemplate>
            <div style="padding: 15px; border-top: 2px solid #ddd; background-color: #f5f5f5;">
              <h5 class="text-base font-semibold mb-2">Detalles del Cambio</h5>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2">
                <ng-container *ngFor="let key of row.detallesCambio | keyvalue">
                  <div>
                    <strong class="text-sm block">{{ key.key | uppercase | replaceUnderscore }}:</strong>
                    <span class="text-gray-600 dark:text-gray-300">{{ key.value }}</span>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-row-detail>

        <div class="mt-4">
          <ngx-datatable
            class="material expandable"
            [rows]="filasHistorial"
            [columns]="columnasHistorial"
            [columnMode]="ColumnMode.force"
            [rowDetail]="tablaHistorial"
            [headerHeight]="40"
            [footerHeight]="40"
            [rowHeight]="'auto'"
            [limit]="10"
            [expanded]="historialExpanded"
            (activate)="toggleExpandRow($event.row)">

            <ngx-datatable-column
              [width]="50"
              [cellTemplate]="toggleTemplate"
              [sortable]="false"
              [canAutoResize]="false"
              [resizeable]="false">
            </ngx-datatable-column>

            <ngx-datatable-column *ngFor="let col of columnasHistorial" [name]="col.name" [prop]="col.prop">
            </ngx-datatable-column>

          </ngx-datatable>

          <ng-template #toggleTemplate let-row="row" let-expanded="expanded">
            <a href="javascript:void(0)"
               [class.datatable-icon-right]="!expanded"
               [class.datatable-icon-down]="expanded"
               title="Expandir Detalle"
               (click)="toggleExpandRow(row)">
            </a>
          </ng-template>

          <p *ngIf="!filasHistorial || filasHistorial.length === 0" class="text-center mt-4 text-gray-500">
            No se encontraron registros de historial para este vehículo.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
